// frontend/src/components/CustomerNotificationBell.js
// W3 — Bell icon with unread badge for the customer-facing header. Links to
// /notifications (any authenticated user). Polls the unread-count endpoint
// and refreshes on auth changes.

import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { FaBell } from "react-icons/fa";

const DEFAULT_API = process.env.REACT_APP_API_BASE_URL || "https://api.ogestyle.com";

function CustomerNotificationBell({ className = "" }) {
  const [unreadCount, setUnreadCount] = useState(0);

  const getToken = () => localStorage.getItem("ogestyle_token");

  const fetchUnread = useCallback(async () => {
    const token = getToken();
    if (!token) {
      setUnreadCount(0);
      return;
    }
    try {
      const res = await fetch(
        `${DEFAULT_API}/api/looks-social/notifications/unread-count`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const data = await res.json();
      if (res.ok) setUnreadCount(Number(data.unreadCount) || 0);
    } catch (err) {
      // Non-fatal — badge stays at its current value.
    }
  }, []);

  useEffect(() => {
    fetchUnread();
    const interval = setInterval(fetchUnread, 60000);
    window.addEventListener("authStateChanged", fetchUnread);
    window.addEventListener("storage", fetchUnread);
    return () => {
      clearInterval(interval);
      window.removeEventListener("authStateChanged", fetchUnread);
      window.removeEventListener("storage", fetchUnread);
    };
  }, [fetchUnread]);

  const token = getToken();
  if (!token) return null;

  return (
    <Link
      to="/notifications"
      aria-label="Notifications"
      className={className}
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "inherit",
        textDecoration: "none",
        padding: "6px",
      }}
    >
      <FaBell size={18} />
      {unreadCount > 0 && (
        <span
          style={{
            position: "absolute",
            top: "0",
            right: "0",
            minWidth: "16px",
            height: "16px",
            borderRadius: "999px",
            background: "#f59e0b",
            color: "#fff",
            fontSize: "10px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 4px",
            boxSizing: "border-box",
          }}
        >
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </Link>
  );
}

export default CustomerNotificationBell;
